import React from "react";
import {JetbrainsButton, VSCodeButton} from "./Frontpage";
import {BgShape003} from "../components/BgShapes";
import {Helmet} from "react-helmet-async";

export default function StartCodingPage() {
    return (
        <section className="section portal-page">
            <Helmet prioritizeSeoTags>
                <title>Start Coding — Codebuddy AI Coding Assistant</title>
                <link rel="canonical" key="link-canonical" href="https://www.codebuddy.ca/startCoding"/>
                <meta property="description" name="description" key="description" content="Download the Codebuddy AI coding assistant for VS Code or JetBrains. Get started with multi-file AI code editing in your favorite IDE."/>
                <meta property="og:title" name="og:title" key="og:title" content="Start Coding — Codebuddy"/>
                <meta property="og:url" name="og:url" key="og:url" content="https://www.codebuddy.ca/startCoding"/>
            </Helmet>
            <div className="container-xl">
                <div className="style-header bg-neutral-800" style={{padding: "2em", marginBottom: "0"}}>
                    <div className="bg-pattern-wrap"><BgShape003/></div>
                    <div className="content-centered">
                        <h1 className="title-lg">Start Coding</h1>
                    </div>
                </div>
            </div>
            <div className="container-sm padding-lg">
                <div className="container">
                    <JetbrainsButton/>
                    <VSCodeButton/>
                </div>
            </div>
            <div className="container-sm padding-lg">
                <h2>Chrome Extension</h2>
                <p>Use the CodeBuddy Chrome extension to extract the current page and send it to the Codebuddy Plugins
                    in both Jetbrains and VSCode.</p>
                <div className="w-layout-blockcontainer container w-container">
                    <a href="https://chromewebstore.google.com/detail/codebuddy/fhodgjaghckjpbhlhebdnolbffodjlho"
                       className="button-animated w-inline-block">
                        <div className="button-label">Install from the Chrome Webstore</div>
                        <div className="button-hover-background"></div>
                    </a>
                </div>
            </div>
        </section>
    )
}